(function () {
  const MOBILE_MAX = 768;

  function initTrustFeatures(section) {
    const mobileEl = section.querySelector('[data-trust-features-mobile]');
    if (!mobileEl || typeof Swiper === 'undefined') return;

    const paginationEl = section.querySelector('[data-trust-features-pagination]');
    const autoplayDelay = Number(section.dataset.autoplayDelay) || 3000;

    const destroy = () => {
      if (mobileEl.swiper) {
        mobileEl.swiper.destroy(true, true);
      }
    };

    const create = () => {
      destroy();
      if (window.innerWidth > MOBILE_MAX) return;

      new Swiper(mobileEl, {
        loop: section.querySelectorAll('.swiper-slide').length > 1,
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
        },
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    };

    create();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(create, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-trust-features]').forEach(initTrustFeatures);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-trust-features]');
    if (section) initTrustFeatures(section);
  });
})();
